import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UISelect from 'UIComponents/input/UISelect';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import * as ThemeSort from '../../../constants/ThemeSort';
const THEME_SORT_ORDER = [ThemeSort.INSTALL_COUNT_DESC, ThemeSort.NEWEST, ThemeSort.PRICE_ASC, ThemeSort.PRICE_DESC, ThemeSort.RANKING_ASC, ThemeSort.RATING_EASE_OF_USE_DESC, ThemeSort.RATING_SUPPORT_DESC, ThemeSort.RATING_VALUE_DESC, ThemeSort.RATING_PERFORMANCE_DESC];
export const THEME_SORT_OPTIONS = THEME_SORT_ORDER.map(themeSortValue => ({
  messageKey: `marketplace-assets-ui.themes.sort.${themeSortValue}`,
  value: themeSortValue
}));
export function ThemeSortToggleGroup({
  onSelect,
  value
}) {
  return /*#__PURE__*/_jsx(UIToggleGroup, {
    name: "sort",
    children: THEME_SORT_OPTIONS.map(option => /*#__PURE__*/_jsx(UIRadioInput, {
      checked: option.value === value,
      onChange: () => onSelect(option.value),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: option.messageKey
      })
    }, option.value))
  });
}
/* Called during runtime because I18n is not ready when document is loading */

const toSelectOptions = options => options.map(({
  messageKey,
  value
}) => ({
  text: I18n.text(messageKey),
  value
}));

export function ThemeSortDropdown({
  onSelect,
  value
}) {
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    className: "m-right-0",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.sort.label"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      buttonUse: "transparent",
      menuWidth: 250,
      onChange: event => onSelect(event.target.value),
      options: toSelectOptions(THEME_SORT_OPTIONS),
      searchable: false,
      value: value
    })
  });
}